import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable()

export class ToastService{
  duration = 3000;
  constructor(
    private toastController: ToastController,
    private translateService: TranslateService
  ) {}
  
  async errorToast(message) {
    const toast = await this.toastController.create({
      message: message,
      position: 'top',
      color: 'danger',
      duration: this.duration,
      buttons: [
        {
          text: this.translateService.instant('general.close'),
          role: 'cancel'
        }
      ]
    });
    toast.present();
  }

  async successToast(message) {
    const toast = await this.toastController.create({
      message: message,
      position: 'top',
      color: 'success',
      duration: this.duration,
      buttons: [
        {
          text: 'OK',
          role: 'cancel'
        }
      ]
    });
    toast.present();
  }

  async warningToast(message) {
    const toast = await this.toastController.create({
      message: message,
      position: 'top',
      color: 'warning',
      duration: this.duration,
      buttons: [
        {
          text: 'OK',
          role: 'cancel'
        }
      ]
    });
    toast.present();
  }
}